import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/_services/global.service';
import { ModalService } from 'src/app/_services/modal.service';
import { WallPostService } from 'src/app/_services/wall-post.service';
import { InfiniteGridComponent } from 'src/app/ui-library/component/infinite-grid/infinite-grid.component';

@Component({
  selector: 'app-wall-post',
  templateUrl: './wall-post.component.html',
  styleUrls: ['./wall-post.component.css']
})
export class WallPostComponent extends InfiniteGridComponent implements OnInit {

  constructor(
    public global: Global,
    private wallPostService: WallPostService,
    private modalService: ModalService


  ) {
    super(global)

  }

  ngOnInit(): void {
    this.setColumnDefs();

  }
  ngAfterViewInit(): void {
    this.setDatasource((prop) => this.wallPostService.getAll(prop))
  }



  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'ID', field: 'id' },
      {
        headerName: 'Background', field: 'backgroundUrl', sortable: false,
        cellClass: 'img-cell',
        cellRenderer: params => {
          return params.value ? `<img height="80" src="${params.value}" alt="without backgroundUrl"/>` : `-`;
        },
      },
      { headerName: 'Description', field: 'description', sortable: false },

      {
        headerName: 'Media Type', field: 'mediaType',
      },
      { headerName: 'Likes', field: 'numberOfLikes', sortable: true },
      { headerName: 'Views', field: 'numberOfViews', sortable: true },
      { headerName: 'Comments', field: 'numberOfComments', sortable: true },
      { headerName: 'Shares', field: 'numberOfShares', sortable: true },
      { headerName: 'Clicks', field: 'numberOfClicks', sortable: true },
      {
        headerName: 'Action', sortable: false, pinned: 'right',
        minWidth: 90,
        cellRenderer: params => {
          return ` 
          <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>`
        },
        onCellClicked: params => {
          switch (params.event.target.id) {

            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Post Detail')
              break;
          }
        },
      },
    ];
  }

}
